'use client';
import Image from 'next/image';
import { Typography } from '@bgzt/ui';
import { AppBar, LinkByEnvironment, Section, Spacing } from '~/components';

import icCategoryFigure from '~/app/category/_icons/ic_category_figure_4x.webp';
import icCategoryKidult from '~/app/category/_icons/ic_category_kidult_4x.webp';
import icCategoryPlaModel from '~/app/category/_icons/ic_category_pla_model_4x.webp';
import icCategoryDoll from '~/app/category/_icons/ic_category_doll_4x.webp';
import icCategoryToyKidult from '~/app/category/_icons/ic_category_toy_kidult_4x.webp';
import icCategoryKpopIdoll from '~/app/category/_icons/ic_category_kpop_idoll_4x.webp';
import icCategoryJapanBoygroup from '~/app/category/_icons/ic_category_japan_boygroup_4x.webp';
import icCategoryJapanGirlgroup from '~/app/category/_icons/ic_category_japan_girlgroup_4x.webp';
import icCategoryMenClothes from '~/app/category/_icons/ic_category_men_clothes_4x.webp';
import icCategoryWomenClothes from '~/app/category/_icons/ic_category_women_clothes_4x.webp';
import icCategoryBag from '~/app/category/_icons/ic_category_bag_4x.webp';
import icCategoryWatch from '~/app/category/_icons/ic_category_watch_4x.webp';
import icCategoryShoes from '~/app/category/_icons/ic_category_shoes_4x.webp';
import icCategoryFashion from '~/app/category/_icons/ic_category_fashion_4x.webp';
import icCategoryJewelry from '~/app/category/_icons/ic_category_jewelry_4x.webp';
import icCategorySports from '~/app/category/_icons/ic_category_sports_4x.webp';
import icCategoryMusic from '~/app/category/_icons/ic_category_music_4x.webp';
import icCategoryBooks from '~/app/category/_icons/ic_category_books_4x.webp';

import styles from './page.module.css';

export default function CategoryPage() {
  const staticCategories = [
    {
      id: 930100,
      name: '피규어/인형',
      icon: icCategoryFigure,
    },
    {
      id: 910800,
      name: '캐릭터 굿즈',
      icon: icCategoryKidult,
    },
    {
      id: 930300,
      name: '프라모델',
      icon: icCategoryPlaModel,
    },
    {
      id: 930200,
      name: '레고/블럭',
      icon: icCategoryDoll,
    },
    {
      id: 930999,
      name: '토이/키덜트',
      icon: icCategoryToyKidult,
    },
    {
      id: 910999,
      name: 'K-POP 아이돌',
      icon: icCategoryKpopIdoll,
    },
    {
      id: 910100,
      name: '일본 보이그룹',
      icon: icCategoryJapanBoygroup,
    },
    {
      id: 910200,
      name: '일본 걸그룹',
      icon: icCategoryJapanGirlgroup,
    },
    {
      id: 320,
      name: '남성의류',
      icon: icCategoryMenClothes,
    },
    {
      id: 310,
      name: '여성의류',
      icon: icCategoryWomenClothes,
    },
    {
      id: 430,
      name: '가방/지갑',
      icon: icCategoryBag,
    },

    {
      id: 421,
      name: '시계',
      icon: icCategoryWatch,
    },
    {
      id: 405,
      name: '신발',
      icon: icCategoryShoes,
    },
    {
      id: 400,
      name: '패션/잡화',
      icon: icCategoryFashion,
    },
    {
      id: 422,
      name: '쥬얼리',
      icon: icCategoryJewelry,
    },
    ...(process.env.NEXT_PUBLIC_ENV !== 'production'
      ? [
          {
            id: 700,
            name: '스포츠/레저',
            icon: icCategorySports,
          },
          {
            id: 920,
            name: '음반/악기',
            icon: icCategoryMusic,
          },
          {
            id: 900100,
            name: '도서',
            icon: icCategoryBooks,
          },
        ]
      : []),
  ];

  return (
    <div>
      <AppBar back={false} actions={['close']} />
      <Spacing height={10} />
      <Section>
        <Typography variant="T3" color="gray-900" as="h1">
          카테고리
        </Typography>
      </Section>
      <Spacing height={40} />
      <Section>
        <nav aria-label="카테고리 목록">
          <ul className={styles.categoryList} role="list">
            {staticCategories.map((category) => (
              <li key={category.id}>
                <LinkByEnvironment
                  href={`/category/${category.id}`}
                  target="_blank"
                  aria-label={`${category.name} 카테고리로 이동`}
                >
                  <div className={styles.categoryItem}>
                    <div className={styles.icon}>
                      {category.icon && (
                        <Image src={category.icon} alt={`${category.name} 카테고리 아이콘`} width={40} height={40} />
                      )}
                    </div>
                    <Typography variant="L4" color="gray-800">
                      {category.name}
                    </Typography>
                  </div>
                </LinkByEnvironment>
              </li>
            ))}
          </ul>
        </nav>
      </Section>
    </div>
  );
}
